import React from "react"
import { Global, css } from "@emotion/react"

const GlobalStyles = ({ customGlobal = css`` }) => {

	return (
		<Global
			styles={[
				css`
					*,
					*::before,
					*::after {
						box-sizing: inherit;
						margin: 0;
						padding: 0;
					}

					html {
						font-family: sans-serif;
						-ms-text-size-adjust: 100%;
						-webkit-text-size-adjust: 100%;
					}

					body {
						-webkit-font-smoothing: antialiased;
						box-sizing: border-box;
						margin: 0;
					}

					ul,
					ol,
					dl {
						margin: 0;
						padding: 0;
					}

					li {
						list-style: none;
					}
				`,
				customGlobal,
			]}
		/>
	)
}

export default GlobalStyles